import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import DataTable from 'react-data-table-component';
import { Loading } from 'react-loading-ui';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import './App.css';
import * as constants from './Constants';
import environment from './environments/environment';
import CancelModalComponent from './popUpModals/CancelModalComponent';
import SubmitModalComponent from './popUpModals/SubmitModalComponent';


const theadernames = ["Case Name", "Attorney", "Supervisor", "Report Start Date", "Interval"];
const reSpacestheadernames = ["CaseName", "Attorney", "Supervisor", "ReportStartDate", "Interval"];

class BulkCases extends React.Component {
    constructor(props) {
        super(props)
        const custStyles = {
            rows: {
                style: {
                    minHeight: '50px', // override the row height
                },
            },
            headCells: {
                style: {
                    paddingLeft: '4px', // override the cell padding for head cells
                    paddingRight: '4px',
                },
            },
            cells: {
                style: {
                    paddingLeft: '5px', // override the cell padding for data cells
                    paddingRight: '5px',
                },
            },
        };
        this.state = {
            show: false,
            shows: false,
            reDirect: '',
            columns: [],
            setColumns: [],
            data: [],
            setData: [],
            setRetData: [],
            setRetColumns: [],
            errorfile: '',
            customStyles: custStyles,
            savedisabled: false,
            templateHeaders: [],
            validateTemplateError: ''
        }
        //   this.handleClick = this.handleClick.bind(this);
    }
    state = {
        // Initially, no file is selected
        selectedFile: null
    };
    async componentDidMount() {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                email: this.props.userStatus.emailId,
                // userName: this.props.userStatus.userName
            });
        } else {
            this.setState({

                reDirect: '/',

            })
        }
    }
    async toValiadeteFile() {
        this.setState({
            errorfile: "",
        }, () => {
            if (this.state.file === undefined) {
                this.setState({
                    errorfile: "Please select file",
                })
            }
        })
    }
    async onSubmit(event) {
        event.preventDefault();
        await this.toValiadeteFile();
        if (this.state.errorfile === "") {
            this.setState({ shows: true });
        }
    }

    // process CSV data
    processData = dataString => {

        const dataStringLines = dataString.split(/\r\n|\n/);
        const headers = dataStringLines[0].split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
        const list = [];
        for (let i = 1; i < dataStringLines.length; i++) {
            const row = dataStringLines[i].split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
            if (headers && row.length === headers.length) {
                const obj = {};
                for (let j = 0; j < headers.length; j++) {
                    let d = row[j];
                    if (d.length > 0) {
                        if (d[0] === '"')
                            d = d.substring(1, d.length - 1);
                        if (d[d.length - 1] === '"')
                            d = d.substring(d.length - 2, 1);
                    }
                    headers[0] = "CaseName";
                    headers[3] = "ReportStartDate";
                    if (headers[j]) {
                        obj[headers[j]] = d;
                    }
                }

                // remove the blank rows
                if (Object.values(obj).filter(x => x).length > 0) {
                    list.push(obj);
                }
            }
        }


        // prepare columns list from headers
        /* const columns = headers.map(c => ({
              name: c,
              selector: c,
          })); */

        const columns = [
            {
                name: 'Case Name',
                selector: row => row.CaseName,
            },
            {
                name: 'Attorney',
                selector: row => row.Attorney,
            },
            {
                name: 'Supervisor',
                selector: row => row.Supervisor,
            },
            {
                name: 'Report Start Date',
                selector: row => row.ReportStartDate,
            },
            {
                name: 'Interval',
                selector: row => row.Interval,
            },
        ];


        this.setState({ setData: [list] });
        this.setState({ setColumns: [columns] });

        if (headers !== undefined && headers != null && headers.length > 4) {
            for (let i = 0; i < headers.length; i++) {
                this.state.templateHeaders.push(headers[i]);
            }
        }

    }

    handleFileUpload = e => {


        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            /* Parse data */
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary', cellText: false, cellDates: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];

            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_csv(ws, { header: 1, raw: false, dateNF: 'mm/dd/yyyy' });
            const dataStrLines = data.split(/\r\n|\n/);
            const headers = dataStrLines[0].split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
            let messStr = "Please validate column header name as ";
            let flag = true;
            if (headers !== undefined && headers !== null && headers.length > 0) {
                for (let i = 0; i < headers.length; i++) {
                    if (headers[i] !== theadernames[i]) {
                        if (i === 0) {
                            messStr = messStr + " " + theadernames[i];
                        } else {
                            messStr = messStr + ", " + theadernames[i];
                        }
                        flag = false;
                    }
                }
            }

            if (flag) {
                this.processData(data);
            } else {
                this.setState({
                    validateTemplateError: messStr
                });

            }

        };
        this.setState({
            file: file,
        })
        reader.readAsBinaryString(file);
        if (file !== undefined) {
            this.setState({
                errorfile: " ",
            })
        }
    }

    onCloseModal() {
        this.setState({ show: false });
    };
    showModal = () => {
        this.setState({ show: true });
    };
    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    };
    onSubmitModal() {
        this.setState({ shows: false });
    };
    showSubmitModal = () => {
        this.setState({ shows: true });
    };

    onSubmitChanges() {
        this.onSubmitModal();
        this.toSave();
    }

    strCompare(str1, str2) {
        return str1 === str2;
    }
    toSave() {

        let caseVO = [];
        caseVO = this.state.setData[0];
        let userName = this.state.email;

        let messStr = "Please validate column header name as ";
        let flag = true;
        if (this.state.file.size > 10485760) {
            this.setState({
                errorfile: "Please select a file that is less than 10 MB"
            });
        } else {
            if (this.state.templateHeaders.length === 0) {
                flag = false;
                messStr = this.state.validateTemplateError;
            }
            if (this.state.templateHeaders !== undefined && this.state.templateHeaders !== null
                && this.state.templateHeaders.length > 0) {

                for (let i = 0; i < this.state.templateHeaders.length; i++) {

                    if (this.state.templateHeaders[i] !== reSpacestheadernames[i]) {
                        if (i === 0) {
                            messStr = messStr + " " + reSpacestheadernames[i];
                        } else {
                            messStr = messStr + ", " + reSpacestheadernames[i];
                        }
                        flag = false;
                    }
                }
            }
            if (flag) {
                Loading();
                axios.post(environment.postBulkCaseInfoDetails + userName, caseVO)
                    .then(response => {
                        if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                            this.setState({
                                savedisabled: true
                            })

                            //  response.data.
                            // this.setState({ reDirect: '/bulkCases' })
                            this.onSubmitModal();
                            let rcolumns = {};

                            const retColumns = [];

                            rcolumns.name = "CaseName";
                            rcolumns.selector = "CaseName";
                            retColumns.push(rcolumns);
                            rcolumns = {};
                            rcolumns.name = "Attroney";
                            rcolumns.selector = "Attroney";

                            retColumns.push(rcolumns);
                            rcolumns = {};
                            rcolumns.name = "Supervisor";
                            rcolumns.selector = "Supervisor";
                            retColumns.push(rcolumns);
                            rcolumns = {};
                            rcolumns.name = "Status";
                            rcolumns.selector = "Status";
                            rcolumns.wrap = true;
                            retColumns.push(rcolumns);
                            const retList = [];
                            this.setState({ setData: [] });

                            for (let i = 0; i < response.data.caseVOList.length; i++) {
                                let list = {};
                                list.CaseName = response.data.caseVOList[i].caseName;
                                list.Attroney = response.data.caseVOList[i].attorneyName;
                                list.Supervisor = response.data.caseVOList[i].supervisorName;
                                list.Status = response.data.caseVOList[i].comments;
                                retList.push(list);
                            }

                            this.setState({ setData: [retList] });
                            this.setState({ setColumns: [retColumns] });
                            setTimeout(() => {
                                Loading();
                            });
                            toast.success(response.data.apiResponseVO.message,
                                { position: toast.POSITION.TOP_CENTER }
                            )
                        } else {
                            setTimeout(() => {
                                Loading();
                            });
                            toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                        }
                    })
                    .catch((error) => {
                        setTimeout(() => {
                            Loading();
                        });
                        toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
                    });
            } else {
                this.setState({
                    errorfile: messStr
                });
            }
        }
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect to={this.state.reDirect} />
        }
        return (
            <React.Fragment>
                <form onSubmit={(event) => this.onSubmit(event)}>
                    <div className="container pl-0  pr-0 ">
                        <div className="row mt-1 mb-0">
                            <div className="col-md-6">
                                <h4 className="heading" >Bulk Case(s) Upload</h4>
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <div className="col-7" >
                                            <form method="post" enctype="multipart/form-data">
                                                <div className=" form-group files color ml-5" style={{ width: '100%' }}>
                                                    <input type="file" accept=".csv,.xlsx,.xls" onChange={this.handleFileUpload} />

                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <p className="text-danger" >{this.state.errorfile}  </p>
                        <hr></hr>

                        <DataTable style={{ backgroundColor: '#add8e6' }}
                            pagination
                            highlightOnHover
                            columns={this.state.setColumns[0]}
                            data={this.state.setData[0]}
                            customStyles={this.state.customStyles}

                        />
                        <hr></hr>
                        <main>
                            <div className="row mb-2" >
                                <div>

                                    <Link to="/caseSummary"><span
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</span></Link>
                                    <button type="submit"
                                        className="btn btn-primary  " disabled={this.state.savedisabled} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Save  </button>
                                    <button type="button" onClick={this.showModal}
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel </button>


                                </div>

                            </div>
                            <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                            <SubmitModalComponent show={this.state.shows} hideModal={() => this.onSubmitModal()} submitChanges={() => this.onSubmitChanges()}></SubmitModalComponent>

                        </main>
                        <ToastContainer style={{ marginTop: '7%' }} />
                    </div>

                </form>
            </React.Fragment>

        )
    }
}
const mapStateToProps = (state) => {

    return {

        userStatus: state.lognReducer
    }
};

export default connect(mapStateToProps)(BulkCases);